// Guaranty Multi-Signer — query-key factory (stale-after-save convention:
// queryKey arrays live only in *Keys files).

export const guarantyKeys = {
  forLoan: (loanId: string) =>
    ["portfolio-admin", "loan", loanId, "guaranties"] as const,
};
